export default __webpack_public_path__ + "static/media/Vector.5f8de1e6.svg";